module.exports = __webpack_public_path__ + "img/right-arrow.75f355e2.png";